import React from 'react';
import Config from '../../assets/config.json';
import Locale from '../../assets/languages';
import Counter from '../widgets/Counter';

class Header extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			totUsers: 0,
			relArea: 0,
		}
		this.interval = false;
		this.Init = this.Init.bind(this);
		this.Fetch = this.Fetch.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.LoaderToggle
			&& typeof (this.props.LoaderToggle) === 'function')
			this.Init();
	}

	Init() {
		clearInterval(this.interval);

		this.interval = setInterval(() => {
			this.Fetch();
		}, 5000);

		this.Fetch();
	}

	Fetch() {
		this.props.LoaderToggle(true, 'header');

		fetch(Config.API.ENDPOINT,
			{
				method: 'POST',
				mode: 'cors',
				body: JSON.stringify({
					action: 'GetStats',
					token: Config.API.TOKEN,
				})
			})
			.then(res => res.json())
			.then(
				(result) => {
					if (result.status) {
						this.setState({
							totUsers: parseInt(result.results.totUsers),
							relArea: parseInt(result.results.relArea),
						});
					}
					this.props.LoaderToggle(false, 'header');
				},
				(error) => {
					console.error(error);
				}
			)
	}

	render() {
		return <header className="px-4 py-3">
			<h1 className="my-0 text-md-center">
				{Locale.HEADER.TITLE}
			</h1>
			<div className="row text-center">
				<div className="col-6 col-lg mt-2">
					<h2 className="my-0">
						<Counter num={this.state.totUsers} />
					</h2>
					<p className="my-0 small">{Locale.HEADER.TOT_USERS}</p>
				</div>
				<div className="col-6 col-lg mt-2">
					<h2 className="my-0">
						<Counter num={this.state.relArea} />
					</h2>
					<p className="my-0 small">{Locale.HEADER.REL_AREA}</p>
				</div>
			</div>
		</header>
	}
}

export default Header;